"use client";

import { Manrope } from "next/font/google";
import { ThemeProvider as NextThemesProvider } from "next-themes";

const manrope = Manrope({
  subsets: ["latin"],
  variable: "--font-manrope",
});

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <div className={`${manrope.className} ${manrope.variable}`}>
        {children}
      </div>
    </NextThemesProvider>
  );
}
